export default __webpack_public_path__ + "static/media/USDT.ac367edf.svg";